import { render, staticRenderFns } from "./vCombobox.vue?vue&type=template&id=00fa8535"
import script from "./vCombobox.vue?vue&type=script&lang=js"
export * from "./vCombobox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports